import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  API_STATUS_REQ_CREATE,
  API_STATUS_REQ_UPDATE,
} from '../../services/api';
import { closeModal, openModal } from '../../store/modules/ModalActions';
import {
  changeProfessorEditingValue,
  clearProfessorEditing,
  loadProfessorByCPF,
  saveAutoCadastro,
  saveProfessorByCPF,
} from '../../store/modules/ProfessoresActions';
import {
  getElementID,
  getInputFocusInFocusOutAttr,
} from '../../utils/HTMLUtils';
import { getUnmaskedValue } from '../../utils/InputMaskUtils';
import {
  allIsTrue,
  celularIsValid,
  cpfIsValid,
  doubleNameIsValid,
  emailIsValid,
  EMAIL_MAX_LENGTH,
  maskedValueRequiredIsValid,
  NOME_MAX_LENGTH,
  requiredIsValid,
  dateIsValid,
} from '../../utils/ValidationUtils';
import { CustomTextField } from '../CustomTextField';
import EscolasField from '../EscolasField/EscolasField';
import RefreshIcon from '../Icons/RefreshIcon';
import SaveIcon from '../Icons/SaveIcon';
import {
  CPFMaskedInput,
  DateMaskedInput,
  PhoneMaskedInput,
} from '../MaskedInputs';
import NewAutoCompleteField from '../NewAutoCompleteField/NewAutoCompleteField';
import { Col } from './../Col';
import { CustomButton } from './../CustomButton';
import { Row } from './../Row';
import styles from './ProfessorEditModal.scss';
import { GenericModalCadastro } from 'components/GenericModal/GenericModalCadastro';

const rootClassName = styles.rootClassName;
const rootElementId = 'professor-edit-modal';

const INITIAL_STATE = {
  open: false,
  saving: false,
  loading: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,

  nomeChanged: false,
  celularChanged: false,
  emailChanged: false,
  // maeChanged: false,
  dataNascimentoChanged: false,
  // rgChanged: false,
  cpfChanged: false,
  escolasChanged: false,

  focusedFieldName: null,
};

class ProfessorEditModal extends Component {
  validations = {
    nomeIsValid: { status: false },
    celularIsValid: { status: false },
    emailIsValid: { status: false },
    // maeIsValid: { status: false },
    dataNascimentoIsValid: { status: false },
    // rgIsValid: { status: false },
    cpfIsValid: { status: false },
    escolasIsValid: { status: false },
  };

  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };

    this.setValue = this.setValue.bind(this);
    this.setEscolaGestor = this.setEscolaGestor.bind(this);
    this.focusIn = this.focusIn.bind(this);
    this.focusOut = this.focusOut.bind(this);
  }

  changeState(newState) {
    this.setState({
      ...this.state,
      ...newState,
    });
  }

  fieldDisabled() {
    return this.state.saving === true || this.state.loading === true
      ? true
      : false;
  }

  reset() {
    this.setState(INITIAL_STATE);
    this.props.clearProfessorEditing();
  }

  componentWillUnmount() {
    this.reset();
  }

  UNSAFE_componentWillMount() {
    if (this.editing()) {
      this.loadProfessor();
    }
  }

  loadProfessor() {
    this.changeState({
      open: true,
      loading: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });
    this.props.loadProfessorByCPF(
      this.props.cpf,
      () => {
        this.formIsValid(true);
        this.changeState({
          loading: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
          nomeChanged: true,
          celularChanged: true,
          emailChanged: true,
          // maeChanged: true,
          dataNascimentoChanged: true,
          // rgChanged: true,
          cpfChanged: true,
          escolasChanged: true,
        });
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadProfessorEditing,
          options: {
            variant: 'error',
          },
        });
        this.toClose();
      }
    );
  }

  getTitle() {
    if (this.editing()) {
      return this.props.languageValues.editProfessorModalTitle;
    }
    return this.props.languageValues.newProfessorModalTitle;
  }

  getSubmitLabel() {
    if (this.editing()) {
      return this.props.languageValues.salvar;
    }
    return this.props.languageValues.cadastrar;
  }

  setValue(event) {
    this.setState({
      ...this.state,
      [event.target.name + 'Changed']: true,
    });
    this.props.changeProfessorEditingValue(
      event.target.name,
      event.target.value
    );
  }

  simpleValidation(value) {
    return value && value.length > 0 ? true : false;
  }

  nomeIsValid(force) {
    if (force || this.state.focusedFieldName === 'nome') {
      const value = this.props.professores.professorEditing.nome;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.nome.required
      );
      const validation = doubleNameIsValid(
        value,
        this.props.languageValues.validations.nome.validation
      );
      if (!required.status) {
        this.validations.nomeIsValid = required;
        return required;
      }
      if (!validation.status) {
        this.validations.nomeIsValid = validation;
        return validation;
      }
      this.validations.nomeIsValid = {
        status: true,
      };
      return this.validations.nomeIsValid;
    } else {
      return this.validations.nomeIsValid;
    }
  }

  celularValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'celular') {
      const value = this.props.professores.professorEditing.celular;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.celular.required
      );
      const length = celularIsValid(
        value,
        this.props.languageValues.validations.celular.length
      );
      if (!required.status) {
        this.validations.celularIsValid = required;
        return this.validations.celularIsValid;
      }
      if (!length.status) {
        this.validations.celularIsValid = length;
        return this.validations.celularIsValid;
      }
      this.validations.celularIsValid = {
        status: true,
      };
      return this.validations.celularIsValid;
    } else {
      return this.validations.celularIsValid;
    }
  }

  dataNascimentoIsValid(force) {
    if (force || this.state.focusedFieldName === 'dataNascimento') {
      const value = this.props.professores.professorEditing.dataNascimento;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.birthDate.required
      );
      const validation = dateIsValid(
        value,
        this.props.languageValues.validations.birthDate.validation
      );
      if (!required.status) {
        this.validations.dataNascimentoIsValid = required;
        return this.validations.dataNascimentoIsValid;
      }
      if (!validation.status) {
        this.validations.dataNascimentoIsValid = validation;
        return this.validations.dataNascimentoIsValid;
      }
      this.validations.dataNascimentoIsValid = {
        status: true,
      };
      return this.validations.dataNascimentoIsValid;
    } else {
      return this.validations.dataNascimentoIsValid;
    }
  }

  emailValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'email') {
      const value = this.props.professores.professorEditing.email;
      const required = requiredIsValid(
        value,
        this.props.languageValues.validations.email.required
      );
      const validation = emailIsValid(
        value,
        this.props.languageValues.validations.email.validation
      );
      if (!required.status) {
        this.validations.emailIsValid = required;
        return this.validations.emailIsValid;
      }
      if (!validation.status) {
        this.validations.emailIsValid = validation;
        return this.validations.emailIsValid;
      }
      this.validations.emailIsValid = {
        status: true,
      };
      return this.validations.emailIsValid;
    } else {
      return this.validations.emailIsValid;
    }
  }

  // maeIsValid(force) {
  //   if (force || this.state.focusedFieldName === 'mae') {
  //     const value = this.props.professores.professorEditing.mae;
  //     const required = requiredIsValid(
  //       value,
  //       this.props.languageValues.validations.mae.required
  //     );
  //     const validation = doubleNameIsValid(
  //       value,
  //       this.props.languageValues.validations.mae.validation
  //     );
  //     if (!required.status) {
  //       this.validations.maeIsValid = required;
  //       return this.validations.maeIsValid;
  //     }
  //     if (!validation.status) {
  //       this.validations.maeIsValid = validation;
  //       return this.validations.maeIsValid;
  //     }
  //     this.validations.maeIsValid = {
  //       status: true,
  //     };
  //     return this.validations.maeIsValid;
  //   } else {
  //     return this.validations.maeIsValid;
  //   }
  // }

  // rgIsValid(force) {
  //   if (force || this.state.focusedFieldName === 'rg') {
  //     const value = this.props.professores.professorEditing.rg;
  //     const required = requiredIsValid(
  //       value,
  //       this.props.languageValues.validations.rg.required
  //     );
  //     const validation = rgIsValid(
  //       value,
  //       this.props.languageValues.validations.rg.validation
  //     );
  //     if (!required.status) {
  //       this.validations.rgIsValid = required;
  //       return this.validations.rgIsValid;
  //     }
  //     if (!validation.status) {
  //       this.validations.rgIsValid = validation;
  //       return this.validations.rgIsValid;
  //     }
  //     this.validations.rgIsValid = {
  //       status: true,
  //     };
  //     return this.validations.rgIsValid;
  //   } else {
  //     return this.validations.rgIsValid;
  //   }
  // }

  cpfValueIsValid(force) {
    if (force || this.state.focusedFieldName === 'cpf') {
      const value = this.props.professores.professorEditing.cpf;
      const required = maskedValueRequiredIsValid(
        value,
        this.props.languageValues.validations.cpf.required
      );
      const validation = cpfIsValid(
        value,
        this.props.languageValues.validations.cpf.validation
      );
      if (!required.status) {
        this.validations.cpfIsValid = required;
        return this.validations.cpfIsValid;
      }
      if (!validation.status) {
        this.validations.cpfIsValid = validation;
        return this.validations.cpfIsValid;
      }
      this.validations.cpfIsValid = {
        status: true,
      };
      return this.validations.cpfIsValid;
    } else {
      return this.validations.cpfIsValid;
    }
  }

  escolasIsValid() {
    return this.props.professores.professorEditing.escolas.length === 0
      ? {
        status: false,
        error: this.props.languageValues.validations.escolas.required,
      }
      : {
        status: true,
      };
  }

  getEscolasGestor() {
    let escolas = [];
    this.props.professores.professorEditing.escolas.map((escola, index) => {
      if (escola.gestor) {
        escolas.push(escola.idEscola);
      }
      return index;
    });
    return escolas;
  }

  setEscolaGestor(event) {
    let escolas = [];
    const selectedEscolas = event.target.value;
    this.props.professores.professorEditing.escolas.map((escola, index) => {
      if (selectedEscolas.indexOf(escola.idEscola) > -1) {
        escolas.push({
          ...escola,
          gestor: true,
        });
      } else {
        escolas.push({
          ...escola,
          gestor: false,
        });
      }
      return index;
    });
    this.setValue({
      target: {
        name: 'escolas',
        value: escolas,
      },
    });
  }

  formIsValid(force) {
    var arr = [
      this.nomeIsValid(force).status,
      this.celularValueIsValid(force).status,
      this.dataNascimentoIsValid(force).status,
      this.emailValueIsValid(force).status,
      // this.maeIsValid(force).status,
      // this.rgIsValid(force).status,
      this.editing(force) ? true : this.cpfValueIsValid().status,
      this.escolasIsValid(force).status,
    ];
    return allIsTrue(arr);
  }

  editing() {
    return this.props.cpf ? true : false;
  }

  toSubmit() {
    if (!this.formIsValid()) {
      return false;
    }

    this.changeState({
      saving: true,
      disableBackdropClick: true,
      disableEscapeKeyDown: true,
    });
    const saveFunction = this.props.isAutoRegister
      ? this.props.saveAutoCadastro
      : this.props.saveProfessorByCPF;
    saveFunction(
      {
        celular: getUnmaskedValue(
          this.props.professores.professorEditing.celular
        ),
        cpf: getUnmaskedValue(this.props.professores.professorEditing.cpf),
        dataNascimento: getUnmaskedValue(
          this.props.professores.professorEditing.dataNascimento
        ),
        email: this.props.professores.professorEditing.email.trim(),
        escolas: this.props.professores.professorEditing.escolas,
        idUsuario: getUnmaskedValue(
          this.props.professores.professorEditing.cpf
        ),
        // mae: this.props.professores.professorEditing.mae.trim(),
        nome: this.props.professores.professorEditing.nome.trim(),
        // rg: this.props.professores.professorEditing.rg.trim(),
        status: 1,
        statusReq: this.editing()
          ? API_STATUS_REQ_UPDATE
          : API_STATUS_REQ_CREATE,
      },
      () => {
        SnackbarUtils.enqueueSnackbar({
          message: this.editing()
            ? this.props.languageValues.successSalvarProfessor
            : this.props.languageValues.successCadastrarProfessor,
          options: {
            variant: 'success',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
        if (typeof this.props.savedCallback === 'function') {
          this.props.savedCallback();
        }
        this.toClose();
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            (this.editing()
              ? this.props.languageValues.erroSalvarProfessor
              : this.props.languageValues.erroCadastrarProfessor),
          options: {
            variant: 'error',
          },
        });
        this.changeState({
          saving: false,
          disableBackdropClick: false,
          disableEscapeKeyDown: false,
        });
      }
    );
  }

  toClose() {
    if (typeof this.props.cancelCallback === 'function') {
      this.props.cancelCallback();
    }
    this.props.closeModal(this.props.modalKey);
  }

  focusIn(fieldName) {
    this.setState({
      ...this.state,
      focusedFieldName: fieldName,
    });
  }

  focusOut(fieldName) {
    if (this.state.focusedFieldName === fieldName) {
      this.setState({
        ...this.state,
        focusedFieldName: null,
      });
    }
  }

  allowEdit() {
    return this.props.auth.userPermissions.professores.edit;
  }

  render() {
    return (
      <GenericModalCadastro
        id={rootElementId}
        onClose={() => {
          this.toClose();
        }}
        titleHint={this.props.languageValues.professorModalHint}
        DialogProps={{
          open: this.props.opened,
          maxWidth: 'sm',
          disableBackdropClick: this.state.disableBackdropClick,
          disableEscapeKeyDown: this.state.disableEscapeKeyDown,
        }}
        title={
          <>
            {this.getTitle()}
            {this.state.loading || this.state.saving ? (
              <RefreshIcon className={rootClassName + '-loading-icon'} />
            ) : null}
          </>
        }
        footerContent={
          <>
            <Row>
              <Col cols={[12, 6, 6, 6, 6]} className='col-legend'>
                <div className='legend'>
                  {this.props.languageValues.campoObrigatorio}
                </div>
              </Col>
            </Row>
            <Row>
              <Col cols={[12, 12, 6, 6, 5]}>
                <CustomButton
                  theme='pufvYellow'
                  className={rootClassName + '-cancel-button'}
                  label={this.props.languageValues.cancelButton}
                  onClick={() => this.toClose()}
                />
              </Col>
              <Col cols={[12, 12, 6, 6, 4]}>
                <CustomButton
                  theme='pufvYellow'
                  className={rootClassName + '-save-buttom'}
                  label={this.getSubmitLabel()}
                  disabled={
                    this.state.loading ||
                    this.state.saving ||
                    !this.formIsValid()
                  }
                  rightIcon={<SaveIcon />}
                  type='submit'
                />
              </Col>
            </Row>
          </>
        }
        onSubmit={(event) => {
          event.preventDefault();
          this.toSubmit();
        }}
      >
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'nome')}
              label={this.props.languageValues.cadastroProfessorNome}
              name='nome'
              value={this.props.professores.professorEditing.nome}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={NOME_MAX_LENGTH}
              helperText={
                this.state.nomeChanged && !this.nomeIsValid().status
                  ? this.nomeIsValid().error
                  : ''
              }
              error={this.state.nomeChanged && !this.nomeIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'email')}
              label={this.props.languageValues.cadastroProfessorEmail}
              name='email'
              value={this.props.professores.professorEditing.email}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={EMAIL_MAX_LENGTH}
              helperText={
                this.state.emailChanged && !this.emailValueIsValid().status
                  ? this.emailValueIsValid().error
                  : ''
              }
              error={
                this.state.emailChanged && !this.emailValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'data-nascimento')}
              label={this.props.languageValues.cadastroProfessorDataNascimento}
              name='dataNascimento'
              value={this.props.professores.professorEditing.dataNascimento}
              onChange={(event) => {
                this.setValue(event);
              }}
              InputProps={{
                inputComponent: DateMaskedInput,
              }}
              helperText={
                this.state.dataNascimentoChanged &&
                  !this.dataNascimentoIsValid().status
                  ? this.dataNascimentoIsValid().error
                  : ''
              }
              error={
                this.state.dataNascimentoChanged &&
                !this.dataNascimentoIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>
        <Row>
          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'celular')}
              label={this.props.languageValues.cadastroProfessorCelular}
              name='celular'
              value={this.props.professores.professorEditing.celular}
              onChange={(event) => {
                this.setValue(event);
              }}
              InputProps={{
                inputComponent: PhoneMaskedInput,
              }}
              helperText={
                this.state.celularChanged && !this.celularValueIsValid().status
                  ? this.celularValueIsValid().error
                  : ''
              }
              error={
                this.state.celularChanged && !this.celularValueIsValid().status
              }
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>

          <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'cpf')}
              label={this.props.languageValues.cadastroProfessorCPF}
              name='cpf'
              value={this.props.professores.professorEditing.cpf}
              onChange={(event) => {
                this.setValue(event);
              }}
              helperText={
                !this.editing() &&
                  this.state.cpfChanged &&
                  !this.cpfValueIsValid().status
                  ? this.cpfValueIsValid().error
                  : ''
              }
              error={
                !this.editing() &&
                this.state.cpfChanged &&
                !this.cpfValueIsValid().status
              }
              disabled={this.editing() ? true : this.fieldDisabled()}
              InputProps={{
                inputComponent: CPFMaskedInput,
              }}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row>

        {/* <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <CustomTextField
              id={getElementID(rootElementId, 'mae')}
              label={this.props.languageValues.cadastroProfessorMae}
              name='mae'
              value={this.props.professores.professorEditing.mae}
              onChange={(event) => {
                this.setValue(event);
              }}
              counter={true}
              maxSize={NOME_MAE_MAX_LENGTH}
              helperText={
                this.state.maeChanged && !this.maeIsValid().status
                  ? this.maeIsValid().error
                  : ''
              }
              error={this.state.maeChanged && !this.maeIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col>
        </Row> */}
        <Row>
          {/* <Col cols={[12, 6, 6, 6, 6]}>
            <CustomTextField
              id={getElementID(rootElementId, 'rg')}
              label={this.props.languageValues.cadastroProfessorRG}
              name='rg'
              value={this.props.professores.professorEditing.rg}
              onChange={(event) => {
                this.setValue(event);
              }}
              maxSize={10}
              helperText={
                this.state.rgChanged && !this.rgIsValid().status
                  ? this.rgIsValid().error
                  : ''
              }
              error={this.state.rgChanged && !this.rgIsValid().status}
              disabled={this.fieldDisabled()}
              {...getInputFocusInFocusOutAttr(this.focusIn, this.focusOut)}
            />
          </Col> */}
        </Row>
        <EscolasField
          id={rootElementId}
          label={this.props.languageValues.cadastroProfessorEscolasAtua}
          value={this.props.professores.professorEditing.escolas}
          onChange={(escolas) => {
            this.setValue({
              target: {
                name: 'escolas',
                value: escolas,
              },
            });
          }}
          emptyText={this.props.languageValues.validations.escolas.required}
          error={this.state.escolasChanged && !this.escolasIsValid().status}
          disabled={this.fieldDisabled()}
          multiple
        />
        <Row>
          <Col cols={[12, 12, 12, 12, 12]}>
            <NewAutoCompleteField
              id={getElementID(rootElementId, 'escolas-gestor')}
              label={this.props.languageValues.cadastroProfessorEscolasGestor}
              placeholder={''}
              options={this.props.professores.professorEditing.escolas.map(
                (item) => {
                  return {
                    label: item.nome,
                    value: item.idEscola,
                  };
                }
              )}
              value={this.getEscolasGestor()}
              multiple
              onChange={(value) => {
                const currValue = value ? value.map((val) => val.value) : [];
                this.setEscolaGestor({
                  target: {
                    name: 'escolasGestor',
                    value: currValue,
                  },
                });
              }}
              disabled={this.fieldDisabled() || !this.escolasIsValid()}
            />
          </Col>
        </Row>
      </GenericModalCadastro>
    );
  }
}

ProfessorEditModal.propTypes = {
  cpf: PropTypes.string,
  opened: PropTypes.bool,
  modalKey: PropTypes.string.isRequired,
  cancelCallback: PropTypes.func,
  savedCallback: PropTypes.func,
  isAutoRegister: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  professores: state.professores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProfessorEditingValue,
      loadProfessorByCPF,
      clearProfessorEditing,
      saveProfessorByCPF,
      saveAutoCadastro,
      closeModal,
      openModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfessorEditModal);
